/* eslint-disable @typescript-eslint/no-empty-function */
import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-weight-counter',
    templateUrl: './weight-counter.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: WeightCounterComponent,
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WeightCounterComponent implements ControlValueAccessor {
    public readonly startDate = input<string>();
    public readonly endDate = input<string>();
    public readonly applicationDeadlineDate = input<string>();
    public readonly label = input<string>();
    public readonly min = input(0);
    public readonly max = input(100);
    @Input()
    public set formControl(control: FormControl<number>) {
        this._formControl = control;
        if (this._formControl) {
            this._formControl.valueChanges.subscribe(value => {
                this.value = value;
            });
        }
    }
    public readonly isDisabled = input<boolean>();

    private _formControl: FormControl<number>;
    public value: number;
    public onTouched: () => void = () => {};
    public onChange: (value: number) => void = () => {};

    protected decrementBackgroundColor(): string {
        return this.value <= this.min() || this.isDisabled() ? 'rgb(var(--ui-4))' : 'rgb(var(--ui-2))';
    }

    protected incrementBackgroundColor(): string {
        return this.value >= this.max() || this.isDisabled() ? 'rgb(var(--ui-4))' : 'rgb(var(--ui-2))';
    }

    protected iconColor(): string {
        return 'rgb(var(--ui-1))';
    }

    writeValue(value: number): void {
        this.value = value;
    }

    registerOnChange(fn: (value: number) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    public increment(): void {
        if (this._formControl) {
            const newValue = this._formControl.value + 1;
            if (newValue <= this.max()) {
                this._formControl.setValue(newValue);
            }
        }
    }

    public decrement(): void {
        if (this._formControl) {
            const newValue = this._formControl.value - 1;
            if (newValue >= this.min()) {
                this._formControl.setValue(newValue);
            }
        }
    }
}
